export class ToggleClass {
  constructor(settings) {
    this.elements = settings.selector;
    this.target = settings.target;
    this.activeClass = (settings.class) ? settings.class : 'actived';
    this.callback = settings.callback;
    this.blockBodyScroll = (settings.blockBodyScroll) ? settings.blockBodyScroll : false;

    //initiate events
    this.initEvents();
  }

  initEvents() {
    if(this.elements) {
      Array.prototype.forEach.call(this.elements, el => {
          //bind click for each element
          el.addEventListener('click', e => {
              e.preventDefault();

              //trigger toggle
              this.toggle();

              //call the callback passing the event and true if has class
              if(this.callback && typeof(this.callback) === "function")
                  this.callback(e, el.classList.contains(this.activeClass))
          })
      })
    }
  }

  toggle() {

    if(this.elements) {

      //add class to current element
      Array.prototype.forEach.call(this.elements, elToggle => {
        elToggle.classList.toggle(this.activeClass)
      })
    }

    //add class to all elements
    if(Array.isArray(this.target)) {
        Array.prototype.forEach.call(this.target, target => {
            target.classList.toggle(this.activeClass)
        })
    }else{
        if (this.target) this.target.classList.toggle(this.activeClass)
    }

    //block scroll in body
    if(this.blockBodyScroll)
        document.body.classList.toggle('block-scroll')

  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/toggleClass.js